import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';

export type RegisterDirectorsResponse = any;

export class DirectorsRegisteringService {
  public static async registerDirectors(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<RegisterDirectorsResponse> {
    const ddi = payload.ddi;
    const ddd = payload.phone.match(/\(\d+\)/g)?.[0].replace(/\D/g, '');
    const telephone = payload.phone
      .replace(ddd || '', '')
      .replace(/\D/g, '')
      .trim();

    const parsedPayload = {
      name: payload.name,
      gender: payload.gender,
      date_of_birth: payload.dateBirth,
      ddi,
      ddd,
      number: telephone,
      email: payload.email,
      nationality: payload.nationality,
      passport_number: payload.passportNo,
      passport_expiry_date: payload.expiryDate,
      passport_issuing_country: payload.passportIssuingCountry,
      passport_issuing_date: payload.issueDate,
      address: payload.address1,
      complement: payload.address2,
      postal_code: payload.postalCode,
      city: payload.city,
      state: payload.state,
      neighborhood: payload.neighborhood,
      country: payload.country,
      passport: payload.passport,
      document1: payload.document1,
      // document2: payload.document2,
      // local_document: payload.localDocument,
      prove_address: payload.proveAddress,
      company_slug: payload.company_slug,
      // class_of_shares: 1,
      // number_of_shares: 1,
      is_director: 1,
      is_underage: 0,
      occupation: payload?.occupation
    };
    const { data } = await api.post('/shareholders', parsedPayload, config);

    return data;
  }

  public static async updateDirectors(
    api: AxiosInstance,
    directorId: number,
    payload: any,
    config: ServiceBaseConfig
  ): Promise<RegisterDirectorsResponse> {
    // const [ddi, ddd, telephone] = payload.phone.replace(/\s/g, '').split('(').join(' ').split(')').join(' ').split(' ');
    payload = payload?.data || {};
    const [ddi, ddd, telephone] = payload?.phone
      ? payload.phone.replace(/\s/g, '').split('(').join(' ').split(')').join(' ').split(' ')
      : [undefined, undefined, undefined];

    if (payload.dateBirth) {
      payload.dateBirth = payload.dateBirth.replace(/-/g, '/');
    }
    if (payload.expiryDate) {
      payload.expiryDate = payload.expiryDate.replace(/-/g, '/');
    }
    if (payload.passportIssuingCountry) {
      payload.passportIssuingCountry = payload.passportIssuingCountry.replace(/-/g, '/');
    }
    if (payload.issueDate) {
      payload.issueDate = payload.issueDate.replace(/-/g, '/');
    }

    const parsedPayload = {
      name: payload?.name,
      gender: payload?.gender,
      date_of_birth: payload?.dateBirth,
      ddi,
      ddd,
      number: telephone,
      email: payload?.email,
      nationality: payload?.nationality,
      passport_number: payload?.passportNo,
      passport_expiry_date: payload?.expiryDate,
      passport_issuing_country: payload?.passportIssuingCountry,
      passport_issuing_date: payload?.issueDate,
      address: payload?.address1,
      complement: payload?.address2,
      postal_code: payload?.postalCode,
      city: payload?.city,
      state: payload?.state,
      neighborhood: payload?.neighborhood,
      country: payload?.country,
      passport: payload?.passport,
      document1: payload?.document1,
      // document2: payload?.document2,
      prove_address: payload?.proveAddress,
      is_director: 1,
      company_slug: payload?.company_slug
    };
    const { data } = await api.put(`/shareholders/${directorId}`, parsedPayload, config);

    return data;
  }

  public static async getDirector(api: AxiosInstance, id: number, config: ServiceBaseConfig): Promise<RegisterDirectorsResponse> {
    const { data } = await api.get(`/shareholders/${id}`, config);

    return data;
  }
}
